module.exports = __webpack_public_path__ + "img/empty_lockers.812af239.png";